export const safeJsonParse = (value, fallback, label = "JSON value") => {
	if (value === null || value === undefined || value === "") {
		return fallback;
	}

	if (typeof value !== "string") {
		return value ?? fallback;
	}

	try {
		return JSON.parse(value);
	} catch (error) {
		console.warn(`Failed to parse ${label}`, error);
		return fallback;
	}
};
